import Vue from 'vue'
import Router from 'vue-router'
import store from '@/frameworks/store'

/* BasicLayout */
import BasicLayout from '@/frameworks/layouts/BasicLayout'
// import Refresh from '@/frameworks/views/refresh'
// import Redirect from '@/frameworks/views/redirect'
import Home from '@/frameworks/views/home'
import AppLoadingPage from '@/frameworks/views/login/appLoadingPage'
import test from '@/frameworks/views/testDemo/test'
import login from '@/frameworks/views/login'
import Iframe from '@/frameworks/views/iframe'
import noZZJG from '@/frameworks/views/noZZJG'
// import quesition from '@/apps/modules/problem-rectification/index'
// import Page_404 from '@/frameworks/views/errorPage/404'
// import Page_401 from '@/frameworks/views/errorPage/401'

import permissionRouterHook from '@/frameworks/router/permissionRouterHook'

/* Router Modules */
import allModules from '@/apps/appsModuleTable'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

Vue.use(Router)

const add404EmptyRouterForChilds = function (routes) {
  routes.forEach((item) => {
    if (item.children) {
      item.children.push({
        path: '*',
        component: () => import('@/frameworks/views/errorPage/404')
      })
      add404EmptyRouterForChilds(item.children)
    }
  })
}

const toFlatRoutes = function (treeRoutes, parentPaths) {
  const allFlatRoutes = []
  treeRoutes.forEach((item) => {
    const flatRouteInfo = {
      parentPaths: parentPaths,
      paths: [...parentPaths, item.path], // path 数组
      routeObj: item
    }
    allFlatRoutes.push(flatRouteInfo)
    // 如果还有子级，继续递归处理子级.
    if (item.children) {
      const childFlatRoutes = toFlatRoutes(item.children, flatRouteInfo.paths)
      allFlatRoutes.push(...childFlatRoutes)
    }
  })
  return allFlatRoutes
}

const mergeRoutes = function (routes) {
  // 1 先将各级路由按路径放到一个列表中.
  const flatRoutes = toFlatRoutes(routes, [])
  // 2. 再将flat路由列表重新组织成树结构.
  // 2.1 先将flat路由按全路径放到map中，方便后面取用.
  const flatRouteMap = {}
  flatRoutes.forEach((item) => {
    flatRouteMap[item.paths.join('@')] = item.routeObj
    item.routeObj.children = []
  })
  // 2.2 再逐个将子级路由，加到父级的路由的children里.
  flatRoutes.forEach((item) => {
    if (item.parentPaths.length > 0) {
      const parentFullPath = item.parentPaths.join('@')
      flatRouteMap[parentFullPath].children.push(item.routeObj)
    }
  })
  // 2.3 最后筛选出没有父级的路由，返回即可.
  const topRoutes = []
  for (const key in flatRouteMap) {
    if (key.indexOf('@') === -1) {
      topRoutes.push(flatRouteMap[key])
    }
  }
  //   const topRoutes = flatRoutes.filter(item => item.parentPaths.length === 0).map(item => item.routeObj);
  return topRoutes
}

const collectModulesRoutes = function () {
  let routes = []
  allModules.forEach((item) => {
    routes = [...routes, ...item.routes]
  })

  routes = mergeRoutes(routes)
  add404EmptyRouterForChilds(routes)
  return routes
}

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    roles: ['admin','editor']     will control the page roles (you can set multiple roles)
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
    noCache: true                if true ,the page will no be cached(default is false)
  }
**/
export const constantRouterMap = [
  // {
  //   path: '/redirect',
  //   component: BasicLayout,
  //   hidden: true,
  //   children: [
  //     {
  //       path: '/redirect/:path*',
  //       component: Redirect
  //     }
  //   ]
  // },
  {
    path: '/',
    component: login,
    hidden: true
  },
  {
    path: '/app_loading',
    component: AppLoadingPage,
    hidden: true
  },
  {
    path: '/test',
    component: test,
    hidden: true
  },
  {
    path: '',
    component: BasicLayout,
    redirect: 'home',
    children: [
      {
        path: 'home',
        component: Home
      },
      {
        path: 'iframe',
        name: 'Iframe',
        component: Iframe
      },
      {
        path: 'statistics/:id?',
        name: 'Statistics',

        component: Iframe
      },
      {
        path: 'noZZJG',
        name: 'noZZJG',
        component: noZZJG
      }
    ]
  },
  ...collectModulesRoutes()
]

const router = new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
//需要判断是否有组织机构的菜单
var checkUrlArray = [
  '/ZKZB/ZKZBList', //质控指标
  '/ZKJH/ZKJHList', //质控计划
  '/ZKJC/ZKJCListForTask', //质控检查
  '/ZKJCJG/ZKJCJGList', //质控结果查询
  '/ZLGJPlan/ZLGJPlanList', //质量改进计划
  '/ZLGJPJ/ZLGJPJMain', //质量改进评价
  '/SJJCZG/SJJCZGMain', //上级检查整改
  '/FXYPJ/FXYPJList', //分析与评价
  '/GZT/GZTList' //工作台
]
//需要判断是否有质控组的菜单
var zkzCheckUrlArray = [
  '/ZKJH/ZKJHList', //质控计划
  '/ZKJC/ZKJCListForTask', //质控检查
  '/FXYPJ/ZKJGFXList', //质控结果分析
  '/ZKJCJG/ZKJCJGList', //质控结果查询
  '/ZLGJPlan/ZLGJPlanList', //质量改进计划
  '/ZLGJPJ/ZLGJPJMain', //质量改进评价
  '/GZT/GZTList' //工作台
]
router.beforeEach((to, from, next) => {
  if (!checkUrlArray.includes(to.path)) {
    next()
  } else if (store.state.user.orgList.length !== 0) {
    next()
  } else if (zkzCheckUrlArray.includes(to.path)) {
    if (store.state.user.ZKZList.length === 0) {
      next({
        path: '/noZZJG'
      })
    } else {
      next()
    }
  } else {
    next({
      path: '/noZZJG'
    })
  }
})

// 注册路由钩子，实现路由权限控制
permissionRouterHook(router)

export default router
